









































































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'Terms',
    setup() {
        const adminMail = process.env.VUE_APP_ADMIN_MAIL;

        return { adminMail };
    },
});
